module.exports = __webpack_public_path__ + "img/icon_card.3a01d327.png";